import { createApp } from 'vue'
import App           from './App.vue'
import router        from '@/classes/Router/Router'
import { store }     from '@/classes/Core/Store'
import CorePlugin    from '@/plugins/Core'
import VueCookies    from 'vue-cookies'

createApp( App )
    .use( router )
    .use( store )
    .use( VueCookies, { expires: '24h' } )
    .use( CorePlugin, store, router )
    .mount( '#app' )
